import { render, staticRenderFns } from "./search.vue?vue&type=template&id=520a6ce2&"
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppBreadCrumb: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppBreadCrumb.vue').default,SearchQueryBox: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/search/SearchQueryBox.vue').default,ProductMain: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/plp/ProductMain.vue').default,SearchLoadingIndicator: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/SearchLoadingIndicator.vue').default})
